import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { GetSubscriptionSetData } from "../../../Api/ServiceDatas";
import { useApi } from "../../../hooks/useApi";
import LineBox from "../../DefaultStyles/LineBox";
import Pagination from "../../Table/Pagination";
import Table, { TableBody, TableBodyItem } from "../../Table/Table";
import {
  ChatSection,
  ChatSectionTitle,
} from "../Party/ChatInfo/ChatSearch/ChatSearchResult";
import { getSubsNameBySubsId3 } from "../../../AdminApi/3.0_utils";

interface IMatchingLog {
  edate: string;
  groupId: string;
  id: string;
  logdate: string;
  logtype: number;
  name: string;
  nickname: string;
  pmax: number;
  pmin: number;
  sdate: string;
  servsubsid: number;
  uid: string;
}

interface MatchingLogProps {
  type?: string;
  filter: {
    type: string;
    typeLabel: string;
    searchValue: string;
    searchType: string;
    startDate: string;
    endDate: string;
    isDateClick: boolean;
  };
  onSavePage?: () => void;
}

export default function MatchingLog({ type, filter, onSavePage }: MatchingLogProps) {
  const navigate = useNavigate();
  const [page, setPage] = useState(0);

  const { response } = useApi({
    method: "get",
    url:
      type === "106"
        ? `log/matching?page=${page}&size=10` +
          (filter?.searchValue !== ""
            ? `&${filter?.searchType}=${filter?.searchValue}`
            : ``) +
          (filter?.endDate !== ""
            ? `&startdate=${filter?.startDate}&enddate=${filter?.endDate}`
            : ``)
        : ``,
  });

  const matchingHeader = [
    "ID",
    "UID_이름_닉네임",
    "그룹 ID",
    "상태",
    "Subscription",
    "매칭 시작일",
    "매칭 종료일",
    "파티 기간",
    "로그 시간",
  ];

  useEffect(() => {}, [filter]);

  if (response?.status !== 200) return <></>;
  else {
    return (
      <ChatSection>
        <ChatSectionTitle>매칭 로그</ChatSectionTitle>

        <LineBox>
          <Table tableHeadData={matchingHeader} tableMinWidth={1180}>
            {response?.data?.items?.map((d: IMatchingLog) => (
              <TableBody key={d?.id}>
                <TableBodyItem>{d?.id}</TableBodyItem>
                <TableBodyItem
                  clickable={true}
                  onClick={() => {
                    onSavePage?.();
                    navigate(`/users/info/${d?.uid}`);
                  }}
                >
                  {d?.uid}_{d?.name}_{d?.nickname}
                </TableBodyItem>
                <TableBodyItem>{d?.groupId}</TableBodyItem>
                <TableBodyItem>
                  {d?.logtype === 4
                    ? "요청 실패"
                    : d?.logtype === 3
                    ? "요청 취소"
                    : d?.logtype === 2
                    ? "요청 성공"
                    : "요청"}
                </TableBodyItem>
                <TableBodyItem>
                  {d?.servsubsid}_{getSubsNameBySubsId3(d?.servsubsid)}
                </TableBodyItem>
                <TableBodyItem>{d?.sdate}</TableBodyItem>
                <TableBodyItem>{d?.edate}</TableBodyItem>
                <TableBodyItem>
                  {d?.pmin}~{d?.pmax}
                </TableBodyItem>
                <TableBodyItem>
                  {dayjs(d?.logdate)?.format("YYYY-MM-DD HH:mm")}
                </TableBodyItem>
              </TableBody>
            ))}
          </Table>

          <Pagination
            totalPage={response?.status === 200 ? response.data.totalPage : 10}
            currentPage={page}
            pageClickEvent={(index) => setPage(index)}
          />
        </LineBox>
      </ChatSection>
    );
  }
}
